import React, { useState } from 'react'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { useSelector } from 'react-redux'
import { State } from '../types/state'
import { Fab } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import DeleteSubjectDialog from './DeleteSubjectDialog'
import { useIsLargeView, useIsMobileView } from '../hooks/useIsMobileView'
import NewOrEditSubjectDialog from './NewOrEditSubjectDialog'
import Button from '@mui/material/Button'
import { useNavigate } from 'react-router'

const Subjects = (): JSX.Element => {
  const { subjects } = useSelector((state: State) => state.user)
  const [selectedRowIds, setSelectedRowIds] = useState<number[]>([])
  const [selectedRowIdsToDelete, setSelectedRowIdsToDelete] = useState<
  number[]
  >([])
  const [subject, setSubject] = useState<any | null>(null)
  const [isNewOrEditSubjectDialogOpen, setIsNewOrEditSubjectDialogOpen] =
    useState(false)
  const [isDeleteSubjectDialogOpen, setIsDeleteSubjectDialogOpen] =
    useState(false)
  const isMobileView = useIsMobileView()
  const isLargeView = useIsLargeView()
  const navigate = useNavigate()

  const IndexesList: React.FC<{ id: number }> = ({ id }) => {
    const subject = subjects.find(g => g.id === id)!

    return <div>{subject.indexes.map(i => i.index).join(', ')}</div>
  }

  const OptionsButton: React.FC<{ id: number }> = ({ id }) => {
    return (
      <div>
        <Fab
          size='small'
          onClick={() => {
            setSubject(subjects.find(g => g.id === id) as any)
            setIsNewOrEditSubjectDialogOpen(true)
          }}
          color='warning'
          aria-label='edit'
          style={{ transform: 'scale(0.8)' }}
        >
          <EditIcon />
        </Fab>
        <Fab
          size='small'
          onClick={() => {
            setSelectedRowIdsToDelete([id])
            setIsDeleteSubjectDialogOpen(true)
          }}
          color='error'
          aria-label='delete'
          style={{ transform: 'scale(0.8)' }}
        >
          <DeleteIcon />
        </Fab>
        <Button
          variant='contained'
          style={{ fontSize: 11 }}
          onClick={() => navigate(`/subjects/${id}`)}
        >
          Subject
        </Button>
      </div>
    )
  }

  const columns: GridColDef[] = [
    { field: 'name', headerName: 'Subject Name', width: 200 },
    {
      field: 'indexes',
      headerName: 'Subject Group',
      width: 200,
      renderCell: params => <IndexesList id={params.row.id} />
    },
    {
      field: 'options',
      headerName: '',
      width: 300,
      renderCell: params => <OptionsButton id={params.row.id} />
    }
  ]

  return (
    <div
      style={{
        height: isMobileView ? '75vh' : '60vh',
        width: isMobileView ? '80vw' : isLargeView ? '50vw' : '70vw',
        margin: 'auto',
        marginBottom: '5vw'
      }}
    >
      <Fab
        size='small'
        color='primary'
        aria-label='add'
        onClick={() => {
          setSubject(null)
          setIsNewOrEditSubjectDialogOpen(true)
        }}
        style={{ margin: '1vw' }}
      >
        <AddIcon />
      </Fab>
      <Fab
        size='small'
        onClick={() => {
          setSelectedRowIdsToDelete(selectedRowIds)
          setIsDeleteSubjectDialogOpen(true)
        }}
        color='error'
        aria-label='delete'
        disabled={selectedRowIds.length === 0}
      >
        <DeleteIcon />
      </Fab>
      <DataGrid
        disableRowSelectionOnClick
        rows={subjects}
        columns={columns}
        checkboxSelection
        onRowSelectionModelChange={newSelection => {
          setSelectedRowIds(newSelection as number[])
        }}
      />
      {isNewOrEditSubjectDialogOpen && (
        <NewOrEditSubjectDialog
          handleClose={() => setIsNewOrEditSubjectDialogOpen(false)}
          subject={subject}
        />
      )}
      {isDeleteSubjectDialogOpen && (
        <DeleteSubjectDialog
          handleClose={() => setIsDeleteSubjectDialogOpen(false)}
          ids={selectedRowIdsToDelete}
        />
      )}
    </div>
  )
}

export default Subjects
